import React, { ReactNode, VFC } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import TimelineContent from '@material-ui/lab/TimelineContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  timelineContent: {
    paddingTop: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      padding: '10px 0 0 10px',
    },
  },
  content: {
    marginBottom: theme.spacing(2),
    '&.bold': {
      fontWeight: 'bold',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: 4,
    },
  },
}));

interface Props {
  title: ReactNode;
  children: ReactNode;
}
const AccordionTimeLineContent: VFC<Props> = ({ title, children }: Props) => {
  const classes = useStyles();
  return (
    <TimelineContent className={classes.timelineContent}>
      <Typography className={clsx(classes.content, 'bold')}>{title}</Typography>
      {children}
    </TimelineContent>
  );
};

export default AccordionTimeLineContent;
